import { render } from "./BankStatementVerification.vue?vue&type=template&id=647296ca&scoped=true"
import script from "./BankStatementVerification.vue?vue&type=script&lang=js"
export * from "./BankStatementVerification.vue?vue&type=script&lang=js"

import "./BankStatementVerification.vue?vue&type=style&index=0&id=647296ca&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647296ca"]])

export default __exports__